import { type JobActivity } from '@airship-platform/jobs-activities-feature/schema';

export interface JobsActivitiesState {
  ids: string[];
  entities: Record<string, JobActivity>;
  selectedAppointmentId: string | null;
  selectedProposalId: string | null;
  error: string | null;
  isLoaded: boolean;
  isLoading: boolean;
}

type Action =
  | {
      type: 'FETCH_JOBS_ACTIVITIES';
      payload: {
        appointmentId: string;
        appointmentProposalId: string;
      };
    }
  | {
      type: 'FETCH_JOBS_ACTIVITIES_SUCCESS';
      payload: {
        activities: JobActivity[];
      };
    }
  | {
      type: 'FETCH_JOBS_ACTIVITIES_FAILURE';
      payload: {
        error: string;
      };
    }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: JobsActivitiesState = {
  ids: [],
  entities: {},
  selectedAppointmentId: null,
  selectedProposalId: null,
  error: null,
  isLoaded: false,
  isLoading: false,
};

export const jobsActivitiesReducer = (
  state: JobsActivitiesState,
  action: Action
): JobsActivitiesState => {
  switch (action.type) {
    case 'FETCH_JOBS_ACTIVITIES':
      return {
        ...state,
        error: null,
        isLoading: true,
        isLoaded: false,
        selectedAppointmentId: action.payload.appointmentId,
        selectedProposalId: action.payload.appointmentProposalId,
      };
    case 'FETCH_JOBS_ACTIVITIES_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.activities.map((a) => a.activityId),
          ]),
        ],
        entities: action.payload.activities.reduce(
          (prev, curr) => ({ ...prev, [curr.activityId]: curr }),
          state.entities
        ),
      };
    case 'FETCH_JOBS_ACTIVITIES_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };
    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
